import React, { useState } from 'react';
import { View } from '@uncinc/react-drupal-core';
import { useTranslation } from 'react-i18next';

import config from 'react-global-configuration';
import {
  Container,
  CoreLink,
  Divider,
} from '../../../components';

import {
  FooterMenu,
  FooterSecondaryMenu,
  FooterCopyrightMenu,
  FooterMenuWithImages,
} from '../..';

const FooterFull = () => {
  const [menusToggled, setMenusToggled] = useState([]);
  const { t } = useTranslation();

  const toggleMenu = (key) => {
    setMenusToggled((prevState) => ({
      ...menusToggled,
      [key]: !prevState[key],
    }));
  };

  return (
    <div className="Footer">
      <FooterMenu toggleMenu={toggleMenu} menusToggled={menusToggled} />
      {config.get('CURRENT_DOMAIN') !== 'kp'
      && (
        <><Divider />
          <Container>
            <div className="Footer__secondary row">
              {/* Region for secondary footer menu */}
              <FooterSecondaryMenu />
              {/* Region for secondary footer supporters */}
              <div className="Footer__secondary--support col-sm-12 col-sm-7 col-md-7 order-sm-2 order-md-2">
                <div className="row">
                  <div className="Footer__secondary__supported col-sm-12 col-md-6">
                    <FooterMenuWithImages id="footer-supported-by" title="Gesteund door" />
                  </div>
                  <div className="Footer__secondary__registered col-sm-12 col-md-6">
                    <FooterMenuWithImages id="footer-registered-by" title="Geregistreerd bij" />
                  </div>
                </div>
              </div>
            </div>
          </Container>
          <div className="">
            <Divider />
            <View id="partners" display="block_1" />
          </div>
        </>
      )}
      <Divider />
      {config.get('CURRENT_DOMAIN') === 'kp'
        && (
          <>
            <Container>
              <div className="Footer__affiliate">
                <div className="Footer__affiliate--text">{t('footer_made_by')} <CoreLink to="https://www.oranjefonds.nl" className="Logo" /></div>
                <FooterMenuWithImages className="FooterKP" id="footer-kp-supported-by" title="Gesteund door" />
              </div>
            </Container>
            <Divider />
          </>
        )}
      <Container>
        <div className="Footer__copyright">
          <div className="Footer__copyright--copyright">Copyright © { new Date().getFullYear()} Oranje Fonds</div>
          <FooterCopyrightMenu />
        </div>
      </Container>
    </div>
  );
};

export default FooterFull;
